<template>
  <article>
    <iframe
      title="map"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d728.7748727829853!2d4.210800696680994!3d51.13674769422986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c38d05a0b6c281%3A0x56d91a92099e1bbc!2sBeekstraat%202%2C%209140%20Temse!5e0!3m2!1sen!2sbe!4v1620929977574!5m2!1sen!2sbe"
      allowfullscreen=""
      loading="lazy"
      class="map"
    ></iframe>
    <div class="info">
      <h3>E'Health & Beauty</h3>
      <p>Enkel op afspraak</p>
      <p>Beekstraat 2</p>
      <p>9140 Temse</p>
      <p>
        <a name="mail" :href="'mailto:' + this.mail">{{ this.mail }}</a>
      </p>
      <p>
        <a name="telefoon" :href="'tel:' + this.tel">{{ this.tel }}</a>
      </p>
    </div>
    <div class="socialsHolder">
      <div>
        <a
          name="facebook"
          target="_blank"
          rel="noopener"
          href="https://www.facebook.com/Ehealthbeauty-102539978663131"
          ><fa class="icon" :icon="['fab', 'facebook']"
        /></a>
        <p>Facebook</p>
      </div>
      <div>
        <a
          name="instagram"
          target="_blank"
          rel="noopener"
          href="https://www.instagram.com/e.health_beauty/"
          ><fa class="icon" :icon="['fab', 'instagram']"
        /></a>
        <p>Instagram</p>
      </div>
      <div>
        <a name="telefoon" :href="'tel:' + this.tel"
          ><fa class="icon" :icon="['fas', 'phone-square-alt']"
        /></a>
        <p>Telefoon</p>
      </div>
      <div>
        <a name="mail" :href="'mailto:' + this.mail"
          ><fa class="icon" :icon="['fas', 'envelope']"
        /></a>
        <p>Mail</p>
      </div>
    </div>
    <img :src="atelier" alt="atelier" class="atelier" />
  </article>
</template>

<script>
import atelier from '../assets/atelier.webp';
export default {
  name: 'Contact',
    data() {
     return {
       atelier: atelier,
        mail: "",
        tel: ""
    }
  },
  created() {
    this.mail = atob("RWxzbW9vcnRoYW1lckBob3RtYWlsLmNvbQ==")
    this.tel = atob("MDQ3MiA0MCAyOCA0OA==")
  }
};
</script>

<style lang="scss" scoped>
article {
  overflow: hidden;
}

.map {
  width: 100%;
  height: 40vh;
  border: none;
}

.info {
  position: absolute;
  top: 20vh;
  left: 3vw;
  background-color: var(--caramel);
  padding: 2em;
  margin: 1em;
  width: 20vw;
  height: 40vh;
  box-shadow: 0px 0px 15px;
  color: var(--text);
  h3 {
    font-size: 1.5em;
    width: 80%;
    padding: 1vh;
    border-bottom: 0.1em solid var(--cookie);
  }

  a {
    text-decoration: none;
    color: var(--text);
    &:hover {
      text-decoration: underline;
    }
  }

  p {
    padding: 0.3em;

    &:first-of-type {
      font-weight: bold;
    }
  }
}

.socialsHolder {
  margin: auto;
  margin-top: 15vh;
  margin-bottom: 15px;
  background-color: var(--caramelTextHolderOverlap);
  width: 40vw;
  height: 30vh;
  box-shadow: 0px 0px 15px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;

  div {
    text-align: center;
    color: var(--white);
    padding: 0.3em;
  }

  .icon {
    font-size: 4em;
    color: var(--white);
    &:hover {
      color: var(--caramel);
    }
  }
}

.atelier {
  z-index: -1;
  position: absolute;
  left: 0;
  top: 46vh;
  width: 100vw;
  height: 53.5vh;
  object-fit: cover;
  opacity: 0.5;
  border-top: 0.5vh solid black;
}

@media only screen and (max-width: 1300px) {
  .info {
    h3 {
      font-size: 1.3em;
    }
    p {
      font-size: 1em;
    }
  }
  .socialsHolder {
    margin-left: 45vw;
    width: 40vw;
  }
}

@media only screen and (max-width: 1000px) {
  .info {
    width: 25vw;
  }
  .socialsHolder {
    margin-left: 45vw;
    width: 40vw;
    .icon {
      font-size: 3.5em;
    }
  }
}

@media only screen and (max-width: 900px) {
  .info {
    width: 30vw;
  }
  .socialsHolder {
    width: 45vw;
    margin-left: 50vw;
    div {
      width: 40%;
    }
    .icon {
      font-size: 3em;
    }
  }
}

@media only screen and (max-width: 700px) {
  .info {
    width: 40vw;
    height: 50vh;
    margin-top: 20vh;
    h3 {
      font-size: 1.3em;
    }
  }
  .socialsHolder {
    margin-top: 5vh;
    margin-left: 60vw;
    width: 25vw;
    height: 40vh;
    div {
      width: 100%;
    }
    p {
      display: none;
    }
    .icon {
      font-size: 3em;
    }
  }
}

@media only screen and (max-width: 550px) {
  .info {
    width: 45vw;
    h3 {
      margin-top: 1vh;
      font-size: 1.1em;
    }
  }
  .socialsHolder {
    width: 20vw;
    margin-left: 70vw;
    .icon {
      font-size: 2.3em;
    }
  }
}

@media only screen and (max-width: 450px) {
  .info {
    top: 46vh;
    left: 0;
    width: 94vw;
    background-color: transparent;
    margin: 0;
    box-shadow: none;
    padding: 3vw;
    padding-bottom: 0;

    p {
      font-size: 0.9em;
    }
  }
  .socialsHolder {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;
    margin: 0;
    height: 10vh;
    box-shadow: none;
    div {
      width: 20%;
    }
  }

  .atelier {
    display: none;
  }
}

@media only screen and (max-width: 350px) {
  .info {
    h3 {
      font-size: 1em;
    }
  }
  .socialsHolder {
    .icon {
      font-size: 2em;
    }
  }
}
</style>